/**
 * Project types are loaded from the backend (options.projectType / ProjectTypeDto).
 * Do not define project type codes or labels in source.
 */

import { ProjectStatusDto } from '@/api/ApiClient';

/** UI labels for {@link ProjectStatusDto} (matches server `Tools/Enums/ProjectStatus.cs`). */
export const PROJECT_STATUS_LABELS: Record<ProjectStatusDto, string> = {
  [ProjectStatusDto.Pending]: 'Pending',
  [ProjectStatusDto.Approved]: 'Approved',
  [ProjectStatusDto.Canceled]: 'Canceled',
  [ProjectStatusDto.Closed]: 'Closed',
};

/** Dropdown order for project status selects. */
export const PROJECT_STATUS_OPTIONS: ProjectStatusDto[] = [
  ProjectStatusDto.Pending,
  ProjectStatusDto.Approved,
  ProjectStatusDto.Canceled,
  ProjectStatusDto.Closed,
];

export function isProjectStatusDto(value: unknown): value is ProjectStatusDto {
  return typeof value === 'string' && value in PROJECT_STATUS_LABELS;
}

/** Display label for a project status code from the API. */
export function getProjectStatusDisplay(status: ProjectStatusDto | string | null | undefined): string {
  if (!status) {
    return '';
  }
  if (isProjectStatusDto(status)) {
    return PROJECT_STATUS_LABELS[status];
  }
  return status;
}

/** Value/label pairs for MUI Select and FormSelect. */
export function projectStatusSelectOptions(): { value: ProjectStatusDto; label: string }[] {
  return PROJECT_STATUS_OPTIONS.map((value) => ({
    value,
    label: PROJECT_STATUS_LABELS[value],
  }));
}
